export default "__VITE_ASSET__BBSMDOsi__"